export default {
    general: {
        add: 'Add', edit: 'Edit', cancel: 'Cancel', save: 'Save', search: 'Search',
        close: 'Close', delete: 'Delete', confirm: 'Confirm', yes: 'YES', no: 'NO',
        loading: 'Loading ...', actions: 'Actions', back: 'Back', copy: 'Copy',
        copied: 'Copied', none: '—',
    },
    errors: {
        too_many_attempts: 'Too many attempts. Please wait a moment and try again.',
        generic_error: 'An error occurred', invalid_data: 'Invalid data',
        not_found: 'Not found', unauthorized: 'Not authorized',
        incorrect_status: 'Action not allowed in this state',
        on_edit: 'Failed to save', login_failed: 'Login failed',
        network: 'Failed to reach the server.',
        stale_build: 'The console has been updated in the meantime. Please reload the page (Cmd/Ctrl + R).',
    },
    success: { add: 'Added successfully', edit: 'Saved successfully', deleted: 'Deleted successfully' },
    about: {
        title: 'About', version: 'Version',
        tagline: 'Central console for on-prem ComplyIT',
        changelog: 'Changelog', powered_by: 'Built by',
    },
    nav: {
        menu: 'Menu',
        tagline: 'VENDOR CONSOLE', overview: 'OVERVIEW', settings_group: 'MANAGEMENT',
        dashboard: 'Dashboard', customers: 'Customers', instances: 'Instances', users: 'Users',
        billing_group: 'BILLING', plans: 'Plans', releases: 'Releases', billing: 'Billing',
        settings: 'Settings',
        remote_access: 'Remote access', mailboxes: 'Mailboxes', mail: 'Mail', support: 'Support',
        help: 'Help', logout: 'Log out',
    },
    remote: {
        title: 'Remote access',
        subtitle: 'Sessions into customer appliances.',
        waiting: 'Waiting for an answer',
        open_now: 'Open now',
        history: 'History',
        empty: 'No sessions yet.',
        asked_by: '{who}, {when}',
        up_to: 'up to {minutes} min',
        approved_by: 'approved by {who}',
        expires: 'expires {when}',
        remaining: '{left} left',
        used: '{n} connections',
        not_used: 'never connected',
        approve: 'Approve',
        deny: 'Refuse',
        end: 'End now',
        approve_intro: 'Approving opens a path to {instance}. The operator agreed to at most {minutes} minutes.',
        grant_minutes: 'Granted duration (minutes)',
        grant_hint: 'You may shorten the session, never lengthen it — the {minutes} min ceiling belongs to the customer.',
        public_key: 'Your SSH public key',
        public_key_hint: 'The appliance installs it for the session and removes it at the end. Remembered locally so you paste it once.',
        approved: 'Session approved.',
        denied: 'Request refused.',
        ended: 'Session ended.',
        col_instance: 'Appliance',
        col_state: 'State',
        col_asked: 'Asked by',
        col_decided: 'Decided by',
        col_used: 'Connections',
        state_requested: 'requested',
        state_approved: 'approved',
        state_active: 'active',
        state_denied: 'refused',
        state_ended: 'ended',
        state_expired: 'expired',
        public_key_optional: 'Empty uses the key from console settings. Fill it in only to use a different one this time.',
        on_host: 'on {host}',
        waiting_appliance: 'Waiting for the appliance — it calls in at its next check-in.',
        on_host_note: 'Working on {host}? Then: ssh -p {port} complyit@127.0.0.1',
    },
    mail: {
        title: 'Mail',
        compose: 'Compose',
        not_configured: 'E-mail is not configured. An admin must set the mailbox credentials in the server .env (INFO_MAILBOX/INFO_PASSWORD and SUPPORT_MAILBOX/SUPPORT_PASSWORD).',
        total: '{n} total',
        from: 'From', to: 'To', subject: 'Subject', date: 'Date', body: 'Message',
        no_subject: '(no subject)',
        empty: 'No messages.',
        empty_body: '(empty message)',
        newer: 'Newer', older: 'Older',
        reply: 'Reply', delete: 'Delete', send: 'Send',
        sent: 'Message sent',
        send_failed: 'Sending failed',
        confirm_delete: 'Move this message to Trash?',
    },
    support: {
        title: 'Support',
        refresh: 'Refresh',
        not_configured: 'The support mailbox is not configured. An admin must set SUPPORT_MAILBOX and SUPPORT_PASSWORD in the server .env.',
        status: 'Status', subject: 'Subject', customer: 'Customer', messages: 'Messages',
        last_activity: 'Last activity',
        no_customer: 'Not linked',
        empty: 'No tickets.',
        status_new: 'New', status_open: 'Open', status_closed: 'Closed',
        mark_open: 'Mark open', mark_closed: 'Close', reopen: 'Reopen',
        you: 'You',
        reply_label: 'Reply',
        reply_placeholder: 'Your reply …',
        send_reply: 'Send reply',
    },
    settings: {
        title: 'Settings', subtitle: 'ComplyIT Admin console settings.',
        email_section: 'E-mail (SMTP)',
        email_hint: 'Outbound SMTP server for notifications. For now mail is only sent via the test button (foundation for future alerts).',
        smtp_host: 'Host', smtp_port: 'Port', smtp_user: 'User',
        smtp_password: 'Password', smtp_from: 'From address',
        password_set_hint: 'Password is set. Leave empty = unchanged.',
        password_empty_hint: 'No password set. Leave empty = unchanged.',
        test_send: 'Send a test message',
        test_recipient: 'Recipient', send_test: 'Send test message',
        test_sent: 'Test message sent', test_failed: 'Sending the test message failed',
        redirect_section: 'E-mail test redirect',
        redirect_hint: 'A safety valve for test environments. It applies to INSTANCE mail only — the console’s own signup e-mails (verification and welcome) always go to the real recipient.',
        redirect_field: 'Redirect all instance mail to address',
        redirect_field_hint: 'Empty = redirect off. Does not affect the console’s signup e-mails.',
        redirect_active_warning: 'Every ComplyIT instance checking in to this console will redirect ALL of its outgoing mail to {email} — a safety valve for test environments.',
        ai_rate_section: 'AI rate (default)',
        ai_rate_hint: 'Global default rate for billing AI token usage. Applies to every customer without its own rate.',
        ai_price_input: 'Input price (€ / 1M)', ai_price_output: 'Output price (€ / 1M)',
        ai_rate_field_hint: 'Price per 1,000,000 tokens. The console bills instance usage at this rate.',
        ai_key_section: 'AI key (vendor-managed)',
        ai_key_hint: 'The console holds the Anthropic key and delivers it to instances on check-in. Since we meter and bill AI usage, the key must be OURS — customers no longer enter their own.',
        ai_enabled: 'AI enabled for all instances',
        ai_enabled_hint: 'Master switch. Turning it off stops key delivery to every instance on its next check-in.',
        ai_api_key: 'Anthropic API key',
        ai_key_set_hint: 'A key is set. Empty = unchanged, "-" = clear.',
        ai_key_empty_hint: 'No key is set. Empty = unchanged, "-" = clear.',
        ai_model: 'Default model',
        ai_model_hint: 'The model instances without their own choice are given. Pick from the list or type a model ID; empty = {model}. Usage is billed at one rate for every model (above).',
        ai_no_key_warning: 'AI is on but no key is set — instances receive nothing and AI will not work for customers.',
        ai_off_warning: 'AI is off: no instance receives a key, even if one is stored.',
        usage_section: 'Usage alerts (plans)',
        usage_hint: 'When a customer’s usage exceeds its plan limits (or comes within 80 % of them), the console alerts US. The alert fires on the transition into that state, at most one per customer every 7 days.',
        usage_alert_email: 'Vendor alert address',
        usage_alert_email_hint: 'Empty = support@comply-it.net. This is our own address, not the customer’s.',
        usage_customer_emails: 'Allow upgrade-suggestion e-mail to customers',
        usage_customer_emails_hint: 'Master switch, OFF by default. Even when on, only customers with their own individual opt-in ever receive it (Customers → edit → Automation).',
        usage_customer_emails_warning: 'Customer-facing e-mail is allowed. Only customers with their own opt-in will receive it.',
        public_section: 'Public pages & e-mail',
        public_hint: 'Details shown on the public signup pages and in the welcome e-mail.',
        support_phone: 'Support phone',
        support_phone_hint: 'Empty = the line is hidden from e-mails.',
        vm_download_url: 'VM image download link',
        vm_download_url_hint: 'Empty = the section is hidden.',
        enroll_section: 'Appliance enroll token',
        enroll_hint: 'A shared secret baked into the ready-made VM image. On first boot an instance self-enrolls with the console using it and appears under "Unclaimed". Generated automatically.',
        enroll_token: 'Enroll token',
        enroll_rotate_warning: 'Rotating the token invalidates the old one immediately — VM images baked with the old token can no longer self-enroll (an image rebuild is required).',
        enroll_rotate: 'Rotate', enroll_rotated: 'Enroll token rotated',
        enroll_rotate_confirm: 'The old token stops working immediately; VM images baked with it can no longer self-enroll. Continue?',
        support_key_title: 'Remote support key',
        support_key_hint: 'The SSH public key the appliance installs for the session and removes at the end. Set here so approving a session needs no paste. Its private half lives on this host, beside the relay.',
        support_key_field: 'SSH public key',
        support_jump_field: 'Jump host',
        support_jump_hint: 'Where ssh enters — the machine the relay runs on, as user@host. Shown in the connect command.',
    },
    ai_models: {
        sonnet: 'balanced, the default',
        opus: 'most capable, most expensive',
        haiku: 'fastest, cheapest',
        fable: 'newest',
        custom: 'typed in by hand',
    },
    help: {
        title: 'Help', subtitle: 'ComplyIT Admin console user guide.',
    },
    login: {
        username: 'Username', password: 'Password', submit: 'Sign in',
        subtitle: 'Central vendor console',
        or: 'or',
        passkey: 'Sign in with a passkey',
        passkey_failed: 'Passkey sign-in failed.',
    },
    passkeys: {
        title: 'Passkeys',
        hint: 'Password-free sign-in with Touch ID, Windows Hello or a security key.',
        add: 'Add passkey',
        label: 'Device name',
        empty: 'No passkeys registered.',
        created: 'Created',
        last_used: 'Last used',
        added: 'Passkey added.',
        failed: 'Passkey registration failed.',
        confirm_delete: 'Delete the passkey “{label}”?',
    },
    dashboard: {
        title: 'Dashboard', subtitle: 'Overview of customers, instances and revenue.',
        kpi_customers: 'Customers', kpi_instances: 'Instances',
        kpi_outdated: 'Outdated instances', kpi_stale: 'Unreachable instances',
        kpi_servers_warning: 'Servers in warning', kpi_mrr: 'Monthly recurring revenue (MRR)',
        kpi_over_plan: 'Customers over plan',
        kpi_over_plan_hint: 'Over plan: {over} (of those still in the 30-day grace period, where nothing is restricted yet: {grace}) · near a limit: {near} · over-paying: {underused}',
        recent_instances: 'Instances', health: 'Health', no_data: 'No data.',
        stale_alert_title: 'Unreachable instances: {count}',
        stale_alert_hint: 'These instances have not checked in for a while. Check connectivity or service health.',
        version_distribution: 'Version distribution', health_distribution: 'Health distribution',
        below_target: 'not on the global target release',
        global_target_is: 'Global target release: {version}', no_global_target: 'No global target release set.',
        instances_without_target: '{count} instance(s) have no target version and will never upgrade. Set a global target release, or pin a version on each.',
        view_all: 'View all',
    },
    filters: {
        search: 'Search', search_placeholder: 'Instance or customer name',
        customer: 'Customer', version_status: 'Version status', health: 'Health',
        all: 'All', uptodate: 'Up to date', outdated: 'Outdated', clear: 'Clear',
        more: 'More filters',
    },
    customers: {
        title: 'Customers', new: 'New customer', edit: 'Edit customer', name: 'Name',
        contact_email: 'Contact email', tax_number: 'Tax number', country: 'Country', notes: 'Notes',
        plan: 'Plan', no_plan: 'No plan', confirm_delete: 'Delete this customer?',
        plans: 'Plans (subscription)',
        merged_preview: 'Granted in total',
        merged_total: 'Monthly total',
        merged_family_hint: 'Numeric limits merge WITHIN a regime: a CRA plan\'s limits do not raise NIS2 limits (or the other way round). AI applies if any subscribed plan grants it.',
        confirm_delete_cascade: 'This customer has {count} instance(s) — they will be deleted too (along with their install tokens). Delete the customer? This cannot be undone.',
        mailbox: 'Mailbox (comply-it.net)', no_mailbox: 'No mailbox created yet.',
        create_mailbox: 'Create mailbox', mailbox_created: 'Mailbox created',
        mailbox_failed: 'The mailbox could not be created. Retry with the "Create mailbox" button.',
        ai_rate_section: 'AI rate (for this customer)',
        ai_price_input: 'Input price (€ / 1M)', ai_price_output: 'Output price (€ / 1M)',
        ai_rate_default: 'default',
        ai_rate_hint: 'Optional. Empty = the global default rate applies. A value here overrides the default for this customer.',
        ai_key_section: 'AI key (for this customer)',
        ai_api_key: 'Own Anthropic API key',
        ai_key_set_hint: 'This customer has its own key. Empty = unchanged, "-" = clear (the vendor key applies).',
        ai_key_empty_hint: 'No own key — the vendor key applies. Empty = unchanged.',
        ai_model: 'Own model',
        ai_model_default: 'vendor default model',
        ai_model_hint: 'Empty = the default model from Settings. A model ID that is not on the list can be typed in.',
        ai_key_hint: 'An own key makes sense when it has to be revocable without touching the whole fleet. Otherwise leave it empty.',
        ai_column: 'AI key',
        ai_state_own: 'Own key',
        ai_state_vendor: 'Vendor key',
        ai_state_off: 'Off',
        trial_until: 'trial until {date}', limited: 'limited',
        filter_plan: 'Plan', filter_all_plans: 'All plans',
        none_on_plan: 'No customer is on the selected plan.',
        upgrade_requested: 'Upgrade requested to {plan}, {date}',
        upgrade_requested_from: 'Raised by instance {instance}',
        upgrade_requested_hint: 'The request is withdrawn automatically once you assign the chosen plan and save. The limits lift on the instance at its next check-in.',
        upgrade_dismiss: 'Dismiss',
        upgrade_dismissed: 'Request dismissed',
    },
    profile: {
        title: 'My profile', name: 'Name', email: 'Email', language: 'Language',
        change_password: 'Change password',
        change_password_hint: 'Leave blank to keep your current password.',
        current_password: 'Current password', new_password: 'New password', confirm_password: 'Confirm new password',
        password_mismatch: 'The new passwords do not match.',
        wrong_password: 'Wrong current password.',
    },
    mailboxes: {
        title: 'Mailboxes', subtitle: 'Manage mailboxes on the {domain} domain (Mailcow).',
        new: 'New mailbox', address: 'Address', name: 'Name', quota: 'Quota (used / total)',
        created: 'Created', empty: 'No mailboxes.',
        not_configured: 'Mailcow is not configured. Set MAILCOW_URL and MAILCOW_API_KEY in the admin-api environment.',
        local_part: 'Local part (before @)', display_name: 'Display name',
        created_ok: 'Mailbox {address} created.',
        password_once: 'Password (shown only once)',
        password_warning: 'Save this password now — it cannot be shown again later.',
        confirm_delete: 'Delete mailbox {address}? This cannot be undone.',
    },
    instances: {
        title: 'Instances', new: 'New instance', customer: 'Customer', name: 'Name',
        version: 'Version', target: 'Target', outdated: 'outdated', uptodate: 'up to date', not_installed: 'Not installed',
        frontend_version: 'Frontend version', backend_version: 'Backend version',
        version_mismatch: 'Frontend and backend versions differ',
        resources: 'Active resources', counts: 'Counts', last_checkin: 'Last check-in',
        checkin_ip: 'IP (last check-in)',
        arch: 'Architecture',
        access_local_only: '· reachable on the customer network',
        access_none: 'The instance has not reported an address yet.',
        no_target: 'no target',
        last_delivered: 'Last told',
        target_pending_hint: 'This instance has not been told the current target yet — it will receive it on its next check-in (up to 15 minutes). The console and the instance are not in conflict; the instance simply has not asked since the target changed.',
        no_target_hint: 'This instance has no target version: it is not pinned and there is no global target release it can inherit. It will never upgrade until a global target is set (or one is pinned here).',
        target_arch_fallback: 'The global target has no image for this architecture, so the newest release this instance can actually run was chosen.',
        arch_unknown: 'unknown',
        arch_unknown_hint: 'This instance does not report its CPU architecture yet, so the console cannot check whether a target release has an image it can run.',
        health: 'Health', detail: 'Instance detail', set_target: 'Set target version',
        target_version: 'Target version', target_hint: 'Empty = use the global target release',
        target_global_option: '— global target release —', target_is_global: 'global target',
        regenerate_key: 'Regenerate API key',
        regenerate_confirm: 'The old key will stop working immediately. Continue?',
        danger_zone: 'Danger zone',
        delete: 'Delete instance',
        delete_hint: 'Permanently deletes this instance and all of its install tokens. This cannot be undone.',
        delete_confirm: 'Permanently delete this instance? Its install tokens will be deleted too. This cannot be undone.',
        api_key_once: 'This key is shown only once — save it now.',
        incidents: 'Incidents', reports: 'Reports', users: 'Users', companies: 'Companies',
        never: 'Never', select_customer: 'Select customer', created_key: 'Instance created. API key:',
        new_key_created: 'New API key:', stale: 'unreachable', online: 'online',
        containers: 'Containers',
        container_warning: 'Some containers are not running, unhealthy, or have restarted',
        upgrade_history: 'Upgrade history', upgrade_when: 'Date/time', upgrade_version: 'Version',
        upgrade_backend: 'Backend', upgrade_empty: 'No upgrades recorded yet.',
        force_update: 'Upgrade now',
        force_update_confirm: 'On its next check-in the instance will be asked to upgrade to the target version immediately. Continue?',
        force_update_started: 'Upgrade request recorded — waiting for the instance to check in.',
        force_update_waiting: 'Waiting for the instance to check in …',
        force_update_hint: 'Available while the instance is outdated. The flag clears once the instance reports the target version (or after 24 h).',
        sources_error: 'sources!',
        sources_error_tooltip: 'At least one enabled connector reports a sync error',
        os_updates_short: 'OS: {n}', os_reboot_short: 'reboot', os_reboot_needed: 'Reboot required',
        unclaimed: 'Unclaimed',
        upgrade_open_customer: 'Open customer',
        unclaimed_badge: 'Unclaimed: {n}', unclaimed_badge_tooltip: 'Show only unclaimed instances (self-enrolled, no customer yet)',
        unclaimed_tooltip: 'Self-enrolled instance not yet assigned to a customer',
        claim_title: 'Unclaimed instance', claim_action: 'Assign to customer',
        claim_hint: 'This instance self-enrolled and is not yet assigned to a customer. Until then it checks in more often and receives no entitlements.',
        claim_existing: 'Existing customer', claim_new: 'New customer', claim_new_name: 'New customer name',
        claim_plan: 'Plan (optional)', claim_plan_none: 'No plan', claim_plan_hint: 'Optional. If you pick a plan, the customer is set to it as part of the assignment.',
        claim_done: 'Instance assigned to customer',
    },
    modules: {
        title: 'Modules (regulatory regimes)',
        source_local: 'Local override',
        local_warning: 'Modules on this instance are set LOCALLY, not by the plan — an instance admin switched a regime on themselves. Set the modules on the customer\'s plan; the next check-ins overwrite the override and this warning disappears.',
        console_hint: 'Modules come from the customer\'s plan.',
    },
    pairing: {
        generate: 'Pair a device',
        generate_confirm: 'Generate a new pairing code? When a device redeems it, this instance\'s key is replaced — if the instance is already running it will stop checking in until you pair it again. Merely generating the code does not disturb a running instance.',
        generated: 'Pairing code generated',
        code_label: 'Pairing code — type this into the wizard on the device\'s first boot',
        expires_in: 'Valid for another {mmss}',
        expired: 'This code has expired — generate a new one.',
        hint: 'The code is valid for 15 minutes and can be used once. The long install command remains available for scripted installs.',
    },
    sources: {
        title: 'Sources / Connectors',
        empty: 'The instance has not reported connector status yet.',
        col_source: 'Source', col_category: 'Category', col_state: 'State',
        col_last_sync: 'Last sync', col_status: 'Status', col_count: 'Items',
        state_enabled: 'Active', state_disabled: 'Disabled', state_unconfigured: 'Not configured',
        status_ok: 'ok', status_error: 'error', status_unconfigured: 'not configured',
        status_blocked: 'blocked', status_none: '—',
        blocked_until: 'Login blocked until {at}',
        never_synced: 'Never synced',
    },
    server: {
        title: 'Server', no_metrics: 'Instance has not reported host metrics yet.',
        cpu: 'CPU', memory: 'Memory', disk: 'Disk', load: 'Load (1 min)', uptime: 'Uptime',
        warn_high: 'High memory or disk usage', warn_crit: 'Critical memory or disk usage',
        os_updates: 'OS updates', os_security: '{n} security pending', os_total: '{n} total',
        os_reboot: 'Reboot required', os_checked: 'checked {rel}',
    },
    console_server: {
        title: 'Console server', containers: 'Containers',
        docker_unavailable: 'Docker is not reachable on this host — showing server metrics only.',
        no_containers: 'No containers.',
        name: 'Name', image: 'Image', state: 'State', restarts: 'Restarts', ports: 'Ports',
    },
    plans: {
        title: 'Plans', new: 'New plan', edit: 'Edit plan', name: 'Name',
        price: 'Monthly price (EUR)', features: 'Features', features_hint: 'One feature per line',
        sort: 'Sort order', per_month: '/mo', confirm_delete: 'Delete this plan?',
        limits_section: 'Plan limits',
        limits_hint: 'Applies to EVERY plan. A positive source count makes the plan limited; the instance enforces the limits.',
        limits_zero_hint: '0 = unlimited (for every field).',
        modules_section: 'Modules (regulatory regimes)',
        modules_hint: 'What the package includes. A customer can buy NIS2, CRA or both — a CRA-only package is perfectly valid (a manufacturer not itself in NIS2 scope).',
        modules_required: 'Pick at least one module. A package with none would entitle the customer to nothing.',
        module_nis2: 'NIS2 — the customer\'s infrastructure',
        module_cra: 'CRA — product placed on the market (Regulation (EU) 2024/2847)',
        modules_unset_hint: 'This package currently leaves modules open: the console says nothing about them and instances keep what they have. Saving makes the console AUTHORITATIVE for modules and overrides any local setting on the instances.',
        limited_badge: 'limited plan', unlimited: 'Unlimited', ai: 'AI', ai_enabled: 'AI enabled',
        max_sources: 'Max sources', max_users: 'Max users',
        max_companies: 'Max companies', max_instances: 'Max instances',
        sum_sources: '{n} source(s)', sum_ai_on: 'with AI', sum_ai_off: 'no AI',
        sum_users: '{n} users', sum_companies: '{n} companies', sum_instances: '{n} instances',
        tagline: 'Short pitch (optional)',
        tagline_hint: 'One line for the website, e.g. "For smaller teams starting with NIS2". Translated together with the features.',
        translations: 'Translations',
        translations_hint: 'The plan copy in the other 23 EU languages. Slovenian is the original; the rest are translations. A missing language falls back to English and then to the original.',
        translate_all: 'Translate into all languages',
        translate_cost_hint: 'ONE AI call covers all 23 languages (not 23 calls). The token usage is reported when it finishes.',
        translate_confirm: 'Translate this plan\'s copy into all 23 languages? Manually edited languages are left untouched.',
        translate_done: 'Translated {n} languages ({skipped} skipped), {tokens} tokens.',
        translate_failed: 'The translation could not be produced.',
        translations_stale: 'The source copy changed — {n} machine translations are out of date. Re-translate when you are ready.',
        translation_manual: 'manual', translation_auto: 'automatic',
        translation_stale: 'out of date', translation_missing: 'not translated',
        translation_name: 'Plan name (optional)',
        translation_name_hint: 'Plan names are NOT translated — Free, Basic, Pro and Enterprise are product names. Fill this in only if this language genuinely needs its own.',
        translation_source: 'Original (Slovenian)',
        translation_manual_hint: 'Saving makes this language MANUAL: later AI runs will never overwrite it.',
        translation_reset: 'Remove translation',
        translation_reset_confirm: 'Remove the translation for this language? The plan will fall back to English, or to the original, for it.',
        public_api: 'The website pricing table is rendered from these plans:',
        public_api_hint: 'A public endpoint with no login; it returns public plan data only (nothing internal). The answer is cached for 5 minutes, so a price change is live on the website within five minutes. Details are in Help (Public plans API).',
    },
    plan_stats: {
        // Per-plan statistics (summary strip and each plan card)
        total_customers: 'Customers', total_mrr: 'Total MRR', total_instances: 'Instances',
        plans_only: 'plan subscriptions only (AI is billed separately)',
        no_plan: 'No plan',
        no_plan_hint: 'Customers with no plan assigned — nobody is billing them. Click to list them.',
        no_customers: 'No customer is assigned to a plan yet.',
        customers_n: '{n} customers', of_mrr: 'of MRR',
        empty_plan: 'No customer is on this plan.',
        active_n: '{n} reported', silent_n: '{n} never reported', instances_n: '{n} instances',
        health_over: 'over plan', health_near: 'near limit', health_underused: 'over-paying', health_within: 'within',
        averages: 'Average utilisation',
        averages_hint: 'Averaged only over customers whose instances have reported; customers without telemetry are in the customer total but not in the average. Unlimited metrics have no ratio and are not shown.',
        no_telemetry: 'No customer on this plan has reported usage yet.',
        no_finite_limits: 'This plan has no finite limits — there is nothing to compare utilisation against.',
    },
    releases: {
        title: 'Releases', new: 'New release', edit: 'Correct release', version: 'Version', docker_image: 'Docker image',
        image_hint: 'Leave empty — the image is derived from the version. If you do name one, its tag must match the release version: the architecture probe reads the tag from this field, not the version, so a wrong tag reports another release\u2019s architectures.',
        notes: 'Notes', published: 'Published', global_target: 'Global target release',
        status:          'State',
        status_upgrading: 'Waiting for the instance to upgrade',
        upgrading_hint:   'The configuration level CANNOT move until the instance runs a release that carries the migration. It is running {version} and pinned to {target}. This is not a refusal — the upgrade has to happen first, and the level then applies (usually within a minute of it).',
        status_idle:     'No target',
        status_waiting:  'Waiting for the instance to report',
        status_applying: 'Applying',
        status_applied:  'Applied',
        status_failed:   'Failed',
        status_stalled:  'Stalled',
        waiting_hint:    'The beat that DELIVERS the target reports the state as it was BEFORE the work — the outcome can only arrive on the next one. While a target is outstanding the instance beats every 60 seconds, so this normally takes a minute or two, not 15.',
        repair_hint:     'Appliances that reached level 1 on instance 1.116.0-1.117.0 have a broken project mount on the updater sidecar: they run normally but can no longer update. Level 2 (instance 1.118.0+) repairs it.',
        set_target: 'Set as global target', is_target: 'TARGET',
        confirm_target: 'Set this release as the global target for all instances?',
        target_set: 'Global target release set', subtitle: 'The upgrade control surface for on-prem instances.',
        platforms: 'Architectures',
        platforms_unknown: 'unknown',
        platforms_unknown_hint: 'The registry has not told us which architectures this release carries. Nothing is blocked — the check is simply skipped.',
        platforms_refreshed: 'Architectures read from the registry',
        refresh_platforms: 'Read architectures from the registry again',
        single_arch_hint: 'Published for {arch} only — instances on another architecture cannot run this release.',
        confirm_target_stranded: '{version} is published for {arches} only. {count} instance(s) would NOT be able to upgrade: {instances}. They will stay on their current version until a release exists for their architecture. Set it as the global target anyway?',
    },
    billing: {
        title: 'Billing', subtitle: 'Monthly recurring revenue per customer.',
        customer: 'Customer', plan: 'Plan', monthly: 'Monthly amount',
        total_mrr: 'Total MRR', no_plan: 'No plan',
        month: 'Month', export_csv: 'Export CSV', exported: 'Export ready',
        plans_subtotal: 'Plans subtotal',
        ai_title: 'AI usage & billing', ai_subtitle: 'Cumulative AI token usage per customer, billed by rate.',
        ai_global_rate: 'Default rate', ai_input_tokens: 'Input tokens', ai_output_tokens: 'Output tokens',
        ai_rate: 'Rate (input / output)', ai_override: 'custom rate', ai_amount: 'Amount', ai_subtotal: 'AI subtotal',
    },
    usage: {
        // Usage vs plan (customer ↔ plan)
        column: 'Usage', card_title: 'Usage and plan',
        no_data: 'No usage data.',
        no_plan_hint: 'This customer has no plan — usage is shown, nothing is judged.',
        peak_hint: 'This customer runs several instances: the highest single-instance value is compared, because a plan limits each instance on its own.',
        status_over: 'over plan', status_near: 'near limit', status_within: 'within',
        status_over_grace: 'over plan (grace until {date})',
        grace_hint: 'Usage exceeds the plan, but the instance restricts NOTHING until {date} — it only warns. After that date only ADDING new items is blocked (sources, users, companies); nothing existing is switched off or deleted.',
        grace_over_hint: 'The 30-day grace period has expired — the plan limits apply. Only adding new items is blocked; nothing existing has been switched off or deleted.',
        status_underused: 'over-paying', status_no_plan: 'no plan',
        metric_sources: 'Connectors', metric_users: 'Users', metric_companies: 'Companies',
        metric_instances: 'Instances', metric_ai: 'AI',
        unlimited: 'unlimited', ai_included: 'included', ai_not_included: 'not in plan',
        suggest_upgrade: 'Suggested plan: {plan} ({price}/mo).',
        suggest_downgrade: 'The cheaper {plan} plan ({price}/mo) would still cover everything they use.',
        suggest_none_covers: 'No existing plan covers this usage — it needs to be priced manually.',
        incidents: 'Incidents', reports: 'Reports',
        incidents_delta: 'Incident growth',
        since_month: 'since {month}',
        only_totals: 'instances report totals only — growth becomes visible after the next monthly snapshot',
        ai_tokens: 'AI tokens', ai_this_month: 'this month', ai_cumulative: 'cumulative total (no previous month snapshot yet)',
        history: 'Growth by month', month: 'Month', audit: 'Automation log',
        audit_auto_upgrade: 'automatic plan upgrade',
        audit_vendor_alert: 'vendor alert',
        audit_customer_email: 'e-mail to customer',
        audit_grace_warn: 'vendor warning before the grace period ends',
        audit_grace_customer_email: 'customer warning before the grace period ends',
        // Automation (per-customer opt-ins)
        automation_section: 'Automation when a plan is exceeded',
        opt_in_email: 'E-mail the customer an upgrade suggestion',
        opt_in_email_hint: 'Off by default. Only takes effect once the master switch in Settings is on as well. Written in the customer’s language, at most one every 7 days.',
        opt_in_auto_upgrade: 'Upgrade the plan automatically',
        opt_in_auto_upgrade_hint: 'Off by default. Raises the plan to the cheapest one that covers the usage; every change is logged and reported to the vendor.',
        // Billing page table
        table_title: 'Usage vs plan',
        table_hint: 'What customers actually use compared with what they pay for. Taken from instance check-in telemetry.',
        issues: 'Exceeded', suggestion: 'Suggestion', current_plan: 'Current plan',
        run_sweep: 'Check usage now',
        sweep_done: 'Sweep complete: {customers} customers, {over} over plan, {near} near a limit, {underused} over-paying.',
        sweep_mails: 'Vendor alerts sent: {vendor}; customer e-mails: {customer}; automatic upgrades: {upgrades}.',
        sweep_failed: 'The usage sweep failed',
        generated_at: 'Refreshed: {time}',
        kpi_line: 'Over plan: {over} (of those in grace: {grace}) · near a limit: {near} · over-paying: {underused}',
        sweep_grace: 'Grace: {started} started, {cleared} cleared, {warnings} expiry warning(s).',
        only_attention: 'Only exceptions',
        no_attention: 'Every customer is within its plan.',
    },
    users: {
        title: 'Users', new: 'New user', edit: 'Edit user',
        name: 'Name', username: 'Username', password: 'Password',
        password_hint: 'Leave blank to keep the current password.',
        role: 'Role', role_admin: 'Administrator', role_viewer: 'Viewer', role_instalater: 'Installer',
        email: 'Email', language: 'Language', you: 'you',
        confirm_delete: 'Delete this user?',
    },
    dns: {
        orphans_title: 'Orphaned DNS records',
        orphans_hint: 'Records in the instance subdomain that no existing instance claims. Records orphaned for more than 7 days are removed automatically; younger ones need a manual confirmation (so a migration in flight is never swept away). Records outside the instance subdomain are never listed and cannot be deleted.',
        orphans_name: 'Record', orphans_type: 'Type', orphans_content: 'Content', orphans_age: 'Orphaned',
        orphans_days: '{n} days', orphans_auto: 'auto-delete',
        orphans_cleanup: 'Clean up orphaned records',
        orphans_confirm: 'Really remove every listed orphaned record from the zone? This cannot be undone.',
        orphans_removed: 'Records removed: {n}',
    },

    appliance: {
        title:      'Appliance configuration',
        reported:   'Reported level',
        target:     'Target',
        no_target:  'No target',
        set_target: 'Set target level',
        failed:     'The appliance could not apply the change',
        hint:       'The console sends ONLY a level number — never file content. The appliance applies only the migrations its own code implements, verifies the result against its own containers, and rolls back when it cannot. Applying the same level twice does nothing. It is set PER INSTANCE; there is deliberately no fleet-wide switch.',
    },
    registry_credential: {
        title:            'Registry credential',
        delivery:         'Delivery over check-in',
        delivery_on:      'Enabled',
        delivery_off:     'Disabled',
        delivery_hint:    'While this is off, the console sends this instance nothing at all. Turning it off later never takes a credential away — the box keeps the one it is already using.',
        held:             'Held by the instance',
        current:          'Current in the console',
        never:            'Never delivered (installer credential)',
        not_configured:   'The console has no registry credential configured (REGISTRY_PULL_USER / REGISTRY_PULL_PASSWORD), so there is nothing to deliver and nothing to compare against.',
        status:           'State',
        status_off:       'Not delivered',
        status_applying:  'Applying',
        status_held:      'Held and verified',
        status_stalled:   'Stalled',
        status_failed:    'Refused — still on the previous credential',
        status_waiting:   'Waiting for the instance to report',
        match:            'This box is provably on the current credential.',
        mismatch:         'This box is NOT on the current credential. Rotating now would strand it.',
        failed:           'The appliance could not take the credential',
        waiting_hint:     'The beat that DELIVERS the credential reports the state as it was BEFORE the work — the outcome arrives on the next one.',
        hint:             'The credential travels ONLY inside the authenticated check-in reply: never in the ISO, never in a URL, never in a log. The appliance verifies a real pull with the new credential BEFORE it replaces the working one, verifies again afterwards, and rolls back to the old one if either check fails. Receiving the same credential twice does nothing. It is set PER INSTANCE; there is deliberately no fleet-wide switch.',
        proof_hint:       'The generation shown is what the instance REPORTS it is holding — not what we sent it. That distinction is the point: a rotation is only safe once every box reports the current generation.',
    },
    tls: {
        title: 'HTTPS / Access',
        not_configured: 'TLS is not configured. The console has no Cloudflare credentials (CLOUDFLARE_DNS_API_TOKEN and CLOUDFLARE_ZONE), so certificates cannot be issued.',
        status_none: 'Not configured', status_issued: 'Issued, expires in {n} days', status_error: 'Error',
        staging: 'STAGING certificate',
        staging_option: 'Use the Let\'s Encrypt staging environment — browsers will not trust it',
        hostname: 'Hostname', hostname_hint: 'Empty = derived from the instance name, under {suffix}. The name can only be changed before the first issuance.',
        ip: 'LAN address (A record)',
        ip_hint: 'The address DNS points at. Empty = the address the instance reports itself.',
        issue: 'Issue', renew: 'Renew', disable: 'Disable',
        disable_confirm: 'The certificate will be removed from the instance on its next check-in and renewals stop. The instance stays reachable over HTTP. Continue?',
        issued: 'Certificate issued — the instance receives it on its next check-in.',
        renewed: 'Certificate renewed.',
        disabled: 'HTTPS disabled.',
        expires: 'Expires', days_left: '{n} days', dns_record: 'Published A record', reported_ip: 'Address reported by the instance',
        hint: 'The console issues the certificate (Let\'s Encrypt, validated over DNS in our own zone) and delivers it to the instance over the authenticated check-in channel. The instance needs no inbound ports from the internet. Renewal runs automatically 30 days before expiry.',
        ip_auto: 'automatic',
        ip_manual: 'manual',
        ip_updated: 'Address updated at {at} ({from} → {to}). The certificate stays valid — it is bound to the name, not the address.',
        ip_unstable: 'The instance changes address too often (more than 6 times an hour), so the record is left alone for now. Recommendation: reserve the address in DHCP or set a fixed address below.',
        pin_ip: 'Fixed address (optional)',
        pin: 'Pin address', unpin: 'Release (automatic)',
        pin_hint: 'Pinning turns off following the address the instance reports — useful for a static address or NAT. An empty field pins whatever is published now.',
        pinned: 'Address pinned — automatic following is off.',
        unpinned: 'Automatic address following is on.',
    },
    install: {
        title: 'Installation',
        intro: 'Generate an install command for this instance. Run it as root on a fresh server (Debian 13) — it self-installs curl, brings up the full ComplyIT stack and links it to this console. No pre-existing curl or sudo required. The command is reusable: it stays valid until the first check-in (first install) or 48h, whichever comes first.',
        generate: 'Generate installer',
        key_warning: 'Generating a new key INVALIDATES the previous one: any earlier install command stops working, and an instance already running on the old key will STOP checking in until you pair it again.',
        command_label: 'Run on the target server (as root):',
        expires: 'The command is valid until the first check-in or {at} (48h) — until then you can run it more than once.',
        vm_hint: 'No server? Ready-made VM image (Debian 13, DHCP):',
        vm_link: 'Download VM image',
        netreq_title: 'Network requirements',
        netreq_intro: 'The ComplyIT server needs outbound TCP 443 to the following domains (plus DNS on port 53):',
        netreq_domains_label: 'Domains (outbound TCP 443):',
        netreq_rule_allow: 'Allow these domains in the firewall web filter (otherwise the proxy returns HTTP 403).',
        netreq_rule_inspect: 'Exclude these domains from SSL/TLS inspection (decryption) — MITM breaks docker login/pull and curl. If inspection cannot be disabled, install the inspection root CA on the server (/usr/local/share/ca-certificates + update-ca-certificates).',
        netreq_lan_note: 'An install against an internal registry on the same LAN (e.g. 192.168.x.x:5000) does not need any of this.',
        generated: 'Install command created',
        generate_confirm: 'Generating invalidates the previous instance key and any earlier install command. Continue?',
        status_waiting: 'waiting for first check-in',
        status_done: 'installed',
        remote_title: 'Install remotely',
        remote_intro: 'Enter the target server address and SSH credentials. The console connects over SSH and runs the installer — progress streams live below.',
        remote_host: 'Address (IP or host)',
        remote_port: 'Port',
        remote_user: 'User',
        remote_password: 'Password',
        remote_user_hint: 'Root mode: connect directly as root.',
        remote_mode: 'Access mode',
        remote_mode_hint: 'Debian disables root SSH password login by default (PermitRootLogin prohibit-password), so on a typical server the real path is “normal user + su”.',
        remote_mode_root: 'root (direct)',
        remote_mode_su: 'normal user + su',
        remote_su_user: 'User (login)',
        remote_su_password: 'User password',
        remote_su_root_password: 'Root password (su)',
        remote_warning: 'The target must be reachable from the console server (public IP or VPN). Passwords are used only for the connection and are NOT stored.',
        remote_run: 'Run install',
        remote_confirm: 'Installing invalidates the previous instance key and brings up the stack on the target server. Continue?',
        remote_started: 'Remote install started',
        remote_running: 'Running',
        remote_success: 'Success',
        remote_failed: 'Failed',
        remote_log_label: 'Install log',
        remote_no_log: 'Waiting for output …',
    },
    health: { ok: 'OK', degraded: 'Degraded', error: 'Error', unknown: 'Unknown', stale: 'Unreachable' },
}
